import { Box } from "@mantine/core";
import { IconQuote } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { InlineMarkdown } from "./InlineMarkdown";

interface QuoteProps {
  author?: string;
  role?: string;
  children: ReactNode;
}

export function Quote({ author, role, children }: QuoteProps) {
  return (
    <Box
      my="xl"
      p="lg"
      style={{
        position: "relative",
        background: "var(--brand-tint-subtle)",
        border: "1px solid var(--brand-tint-strong)",
        borderRadius: 10,
      }}
    >
      <IconQuote
        size={40}
        style={{
          position: "absolute",
          top: 16,
          left: 16,
          opacity: 0.15,
          color: "var(--brand)",
        }}
      />
      <Box
        style={{
          fontStyle: "italic",
          color: "var(--ink-body)",
          lineHeight: 1.65,
          paddingLeft: 24,
          fontSize: 17,
        }}
      >
        <InlineMarkdown>{children}</InlineMarkdown>
      </Box>
      {author && (
        <Box mt="md" pl={24}>
          <Box style={{ fontSize: 14, fontWeight: 600, color: "var(--brand)" }}>
            — {author}
          </Box>
          {role && (
            <Box style={{ fontSize: 12, color: "var(--ink-muted)", marginTop: 2 }}>{role}</Box>
          )}
        </Box>
      )}
    </Box>
  );
}
